// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.ql-toolbar{
    border-radius: 5px 5px 0 0 !important;
}

.ql-container{
    border-radius: 0 0 5px 5px !important;
    height: 170px;
}

.ql-snow .ql-tooltip {
    z-index: 99 !important;
}

.ql-container {
    scroll-margin: 0 !important;
    scroll-behavior: auto !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Global/RichTextEditor/RichTextEditor.css"],"names":[],"mappings":";;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;EAClC","sourcesContent":["\n\n.ql-toolbar{\n    border-radius: 5px 5px 0 0 !important;\n}\n\n.ql-container{\n    border-radius: 0 0 5px 5px !important;\n    height: 170px;\n}\n\n.ql-snow .ql-tooltip {\n    z-index: 99 !important;\n}\n\n.ql-container {\n    scroll-margin: 0 !important;\n    scroll-behavior: auto !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
